import { useContext, useEffect, useState } from "react";

import { useHistory } from "react-router";

import { EditOutlined, Add } from "@material-ui/icons";
import { Container, Grid, Switch, FormControlLabel } from "@material-ui/core";

import RedBall from "../../../assets/imgs/bolinha-vermelha.png";
import GreenBall from "../../../assets/imgs/bolinha-verde.png";

import SpeedDialErp from "../../../components/speeddial/SpeedDialErp";
import Loading from "../../../components/basics/Loading";
import HeaderModule from "../../../components/header/HeaderModule";
import { Margin } from "../../../theme/styles/Utils";
import BigDataTable from "../../../components/tables/BigDataTable";
import TextField from "../../../components/basics/TextFieldErp";
import { BallContainer } from "../../prouser/transportadoras/styles/Transportadora";
import Btn from "../../../components/buttons/Btn";
// import useMotivoCancelamentoController from "./controllers/MotivoCancelamentoController";
import { MotivoCancelamentoContext } from "./context/MotivoCancelamentoContext";
import { GlobalVariables } from "../../../GlobalVariables";

let typingTimer = null;
const MotivoCancelamentoListagem = () => {
  const { loading, dataTableReload } = useContext(MotivoCancelamentoContext);
  // Comentado por ordens superiores
  // const { destroy } = useMotivoCancelamentoController();

  const [textFilter, setTextFilter] = useState("");
  const [showOnlyActives, setShowOnlyActives] = useState(true);
  const [queryOrWhere, setQueryOrWhere] = useState(null);
  const [queryWhere, setQueryWhere] = useState(null);

  const { push } = useHistory();

  useEffect(() => {
    clearTimeout(typingTimer);
    typingTimer = setTimeout(() => {
      setQueryOrWhere({
        descricao: encodeURIComponent(`${textFilter}`),
      });
    }, 1500);
  }, [textFilter]);

  useEffect(() => {
    setQueryWhere({
      liberado: showOnlyActives ? "S" : "N",
    });
  }, [showOnlyActives]);

  const columns = [
    {
      disabled: true,
      id: "acoes",
      label: "Ações",
      align: "center",
      format: (item) => (
        <SpeedDialErp
          actions={[
            {
              icon: <EditOutlined />,
              name: "Editar",
              action: () => push("cadastro", { id: item.id }),
            },
            // Comentado por ordens superiores
            // {
            //   icon: <DeleteOutlineOutlined />,
            //   name: "Excluir",
            //   action: () => destroy(item.id),
            // },
          ]}
        />
      ),
    },
    {
      id: "id",
      label: "ID",
    },
    {
      id: "descricao",
      label: "Descrição",
      style: { minWidth: 275 },
    },
    {
      id: "liberado",
      label: "Ativo",
      align: "center",
      format: (value) =>
        value.liberado === "S" ? (
          <BallContainer>
            <img src={GreenBall} alt="ativo" />
          </BallContainer>
        ) : (
          <BallContainer>
            <img src={RedBall} alt="inativo" />
          </BallContainer>
        ),
    },
  ];

  return (
    <>
      <Loading open={loading} />
      <HeaderModule
        title="CADASTRO DE MOTIVO DE CANCELAMENTO"
        videoId={GlobalVariables.screenVideosIds.cadastroMotivoCancelamento}
      />
      <Margin top="100" />
      <Container maxWidth="xl">
        <Grid container spacing={3}>
          <Grid
            item
            container
            justifyContent="space-between"
            alignItems="flex-end"
          >
            <Grid item xs={12} sm={12} md={7}>
              <TextField
                value={textFilter}
                setValue={setTextFilter}
                label="Busque por Descrição"
                variant="filled"
              />
            </Grid>

            <Grid item xs={6} sm={6} md={3} lg={3}>
              <FormControlLabel
                control={
                  <Switch
                    checked={showOnlyActives}
                    onChange={() => setShowOnlyActives((current) => !current)}
                    color="primary"
                  />
                }
                label="Ativos"
                labelPlacement="end"
              />
            </Grid>

            <Grid item flex={1}>
              <Btn
                label="Novo"
                startIcon={<Add />}
                onClick={() => push("cadastro")}
              />
            </Grid>
          </Grid>
          <Grid item xs={12}>
            <BigDataTable
              tableTitle=""
              route="faturamento/motivoscancelamentos/v1"
              columns={columns}
              where={queryWhere}
              orWhere={queryOrWhere}
              reload={dataTableReload}
            />
          </Grid>
        </Grid>
      </Container>
    </>
  );
};

export default MotivoCancelamentoListagem;
